/**
 * The "Load detail" tab of the Box Truck table settings — how an opened load behaves, as against which
 * columns the table shows.
 *
 * One setting so far, and it is here rather than in the drawer itself because it is a standing preference,
 * not a per-load action: the drawer already has the Expand button for "show me this one".
 */

import { Switch } from '@/components/ds2'

export const BoxTruckLoadDetailSettings = ({
    openMapOnExpand,
    onOpenMapOnExpandChange,
}: {
    openMapOnExpand: boolean
    onOpenMapOnExpandChange: (value: boolean) => void
}) => (
    <div className="flex flex-col gap-4 py-1">
        <label className="flex items-start justify-between gap-4">
            <span className="flex flex-col gap-1">
                <span className="text-sm font-medium text-foreground">Open map when a load is opened</span>
                {/* Says what it costs, because that is why it is off by default: the map was taken off the
                    open path for exactly this reason, and an operator scanning the board pays it per load. */}
                <span className="text-xs text-foreground-muted">
                    Draws the route straight away instead of waiting for Expand. Each load opened then costs a route lookup, so leave it off if you scan the
                    board quickly.
                </span>
            </span>
            <Switch size="sm" checked={openMapOnExpand} onChange={onOpenMapOnExpandChange} ariaLabel="Open map when a load is opened" />
        </label>
    </div>
)
